var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eIdz8Ey9FcX1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21 21",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 21,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIdz8Ey9FcX8-fill",
    x1: 340.0111,
    y1: 483.1085,
    x2: 340.0111,
    y2: 292.3112,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX8-fill-0",
    offset: "0%",
    stopColor: "#f6921a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX8-fill-1",
    offset: "100%",
    stopColor: "#f66d1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIdz8Ey9FcX9-fill",
    x1: 340,
    y1: 196.8846,
    x2: 340,
    y2: 387.7264,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX9-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX9-fill-1",
    offset: "16%",
    stopColor: "#fffcfa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX9-fill-2",
    offset: "35%",
    stopColor: "#fff6ec"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX9-fill-3",
    offset: "54%",
    stopColor: "#ffebd5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX9-fill-4",
    offset: "74%",
    stopColor: "#ffdcb6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX9-fill-5",
    offset: "95%",
    stopColor: "#ffc88d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIdz8Ey9FcX9-fill-6",
    offset: "100%",
    stopColor: "#ffc382"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-329.5-329.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.03 0 0 0.03 329.8 329.8)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 700,
    rx: 350,
    ry: 350,
    transform: "translate(-10-10)",
    fill: "#091c3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M531.6,334l-46.5-27-19.6-11.4c-7.4-4.3-16.6-4.3-24,0l-89.5,52c-7.4,4.3-16.6,4.3-24,0l-89.5-52c-7.4-4.3-16.6-4.3-24,0L194.9,307l-46.5,27c-15.8,9.2-15.8,32,0,41.3L226.6,421l101.5,59c7.4,4.3,16.6,4.3,24,0l101.5-59l78.2-45.7c15.7-9.3,15.6-32.1-.2-41.3v0Z",
    transform: "translate(.000001 0)",
    fill: "url(#eIdz8Ey9FcX8-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.6,238.5l-66.1-38.4c-7.4-4.3-16.6-4.3-24,0l-89.5,52c-7.4,4.3-16.6,4.3-24,0l-89.5-52c-7.4-4.3-16.6-4.3-24,0l-66.1,38.4c-15.8,9.2-15.8,32,0,41.3L194.9,307l31.7,18.5l101.5,59c7.4,4.3,16.6,4.3,24,0l101.5-59L485.3,307l46.5-27.2c15.7-9.2,15.6-32.1-.2-41.3v0Z",
    transform: "translate(.000001 0)",
    fill: "url(#eIdz8Ey9FcX9-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,384.5c7.4,4.3,16.6,4.3,24,0l101.5-59L485.2,307l-19.6-11.4c-7.4-4.3-16.6-4.3-24,0l-89.5,52c-7.4,4.3-16.6,4.3-24,0l-89.5-52c-7.4-4.3-16.6-4.3-24,0L194.9,307l31.7,18.5l101.4,59v0Z",
    fill: "#f6921a"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsc);
export default __webpack_public_path__ + "static/media/esc.dc6058e860805124267232c68cdb0d34.svg";
export { ForwardRef as ReactComponent };